import { getAppUrl, getAppNameWithVersion, } from '@wix/wix-data-client-common-standalone';
import { shouldSendReport } from './shouldSendReport';
export const configureForWorker = ({ Raven, appName, browserUrlGetter, dsn, params, }) => {
    const appUrl = getAppUrl(appName);
    const appVersion = getAppNameWithVersion(appUrl);
    // do not install(), we want to control the error reporting ourselves
    // instead of Raven hooking to everything
    Raven.config(dsn, {
        //the default was 250, increased to 1000 to support long Santa urls with overrides
        maxUrlLength: 1000,
        captureUnhandledRejections: false,
        autoBreadcrumbs: {
            dom: false,
        },
    });
    Raven.setRelease(params.release || appVersion);
    Raven.setShouldSendCallback(params.shouldSendCallback || shouldSendReport);
    Raven.setDataCallback((data, originalCallback) => {
        //in a worker raven does not set this required field which leads to sentry bugs
        data.request = Object.assign(data.request || {}, {
            url: browserUrlGetter(),
        });
        return (originalCallback || ((x) => x))(data);
    });
    const cleanup = () => {
        Raven.setDataCallback(() => { });
    };
    return cleanup;
};
//# sourceMappingURL=configureForWorker.js.map